import {match, Pattern} from 'ts-pattern';

import type {CustomerInsightsRecord} from '../types/CustomerInsightsViewModel';

const getOccurredAtTimestamp = (record: CustomerInsightsRecord) =>
  match(record.occurredAt)
    .with(Pattern.string, (occurredAt) => {
      const timestamp = Date.parse(occurredAt); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible

      return Number.isNaN(timestamp) ? Number.NEGATIVE_INFINITY : timestamp;
    })
    .otherwise(() => Number.NEGATIVE_INFINITY);

const compareOccurredAtNewestFirstThenId = (
  first: CustomerInsightsRecord,
  second: CustomerInsightsRecord
) =>
  getOccurredAtTimestamp(second) - getOccurredAtTimestamp(first) ||
  first.id.localeCompare(second.id);

export function sortCustomerInsightsRecordsByOccurredAt(records: CustomerInsightsRecord[]) {
  return [...records].sort(compareOccurredAtNewestFirstThenId);
}
